/**
 * Group rule messages that share an opening line.
 *
 * A rule message may be written as `heading\ndetail`. Messages with the same
 * heading show it once, with their details listed beneath, so two blocks
 * that start the same way do not repeat the sentence. A message without a
 * line break stands on its own, exactly as written.
 */
export interface RuleMessageGroup {
  key: string
  heading: string | null
  items: string[]
}

export function groupRuleMessages(
  messages: Array<{ key: string; message: string }>,
): RuleMessageGroup[] {
  const groups: RuleMessageGroup[] = []
  const byHeading = new Map<string, RuleMessageGroup>()
  for (const { key, message } of messages) {
    const breakAt = message.indexOf('\n')
    const heading = breakAt >= 0 ? message.slice(0, breakAt).trim() : ''
    const detail = breakAt >= 0 ? message.slice(breakAt + 1).trim() : ''
    if (!heading || !detail) {
      groups.push({ key, heading: null, items: [message] })
      continue
    }
    const existing = byHeading.get(heading)
    if (existing) {
      existing.items.push(detail)
      continue
    }
    const group = { key, heading, items: [detail] }
    byHeading.set(heading, group)
    groups.push(group)
  }
  return groups
}
